/**
 * SPINNER
 * Spinner is globally triggered on every form
 * Use .js-spinner-none class for disable spinner after submit form.
 */
export default () => {

    const spinner = document.querySelector('.js-spinner');
    const forms = Array.from(document.forms)

    for (const form of forms) {

        if ((typeof (form) != 'undefined' && form != null) && !form.classList.contains('js-spinner-none')) {
            form.addEventListener('submit', (e) => {
                spinner.classList.toggle('d-block');
            });
        }

    }
}
